import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../../Types/User/UserModel";
import { ViewUser } from "../../../Types/User/ViewUserModel";
import { UserTableColumn } from "../../../Data/DataTables/User";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import {
  ViewuserService,
  userService,
  USER_QUERY_KEY,
  USER_VIEW_QUERY_KEY,
} from "../../../Services/userService";
import RegisterUserModal from "../../UiKits/Modal/UserModal/RegisterUserModal";

const UserTable = () => {
  const [filterText, setFilterText] = useState("");
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const { data: users = [], isLoading } = useQuery({
    queryKey: USER_VIEW_QUERY_KEY,
    queryFn: ViewuserService.getAllUserView,
  });

  const filteredItems: ViewUser[] = users.filter((item: User) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <RegisterUserModal />
          <FilterComponent
            onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            filterText={filterText}
          />
          <div className="table-responsive">
            <DataTable
              className="custom-scrollbar"
              data={filteredItems}
              columns={UserTableColumn}
              striped={true}
              pagination
              highlightOnHover
              progressPending={isLoading}
              customStyles={customStyles}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserTable;
